import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ChargebeeService {
  constructor(private http: HttpClient) {}

  createHostedPage(plan: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${environment.apiUrl}/payment/create/hosted/${plan}`).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }

  createPortalSession(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${environment.apiUrl}/payment/get/portal-session`).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }

  getSubscriptionByCustomerId(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${environment.apiUrl}/payment/get/list-sub/${id}`)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getListOfPlansByProductId(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${environment.apiUrl}/payment/get/list-plans`)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }
}
